export default {
  name: 'marking--controlSamplesType',
};